import { render, staticRenderFns } from "./sms-receiving.vue?vue&type=template&id=5fa02de8&scoped=true"
import script from "./sms-receiving.vue?vue&type=script&lang=js"
export * from "./sms-receiving.vue?vue&type=script&lang=js"
import style0 from "./sms-receiving.vue?vue&type=style&index=0&id=5fa02de8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa02de8",
  null
  
)

export default component.exports